var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.keepAlive)?_c('keep-alive',{attrs:{"include":_vm.includedComponents}},[_c('router-view')],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }